import toastr from "toastr";
import { call, put, takeEvery } from "redux-saga/effects";
import {
    GET_ALL_ORG_GCP_RESOURCE_TYPES,
    GET_GCP_ALL_RESOURCE_ALERTS_PAGE,
    GET_GCP_CLOUD_RESOURCES,
    GET_GCP_NOTIFICATION_CHANNELS,
    GET_GCP_REFRESH,
    POST_GCP_CREATE_RESOURCE_ALERTS,
    POST_GCP_RESOURCE_OPSGENIE_TEAM_MAPPING,
    POST_GCP_RESOURCE_PAGERDUTY_SERVICE_MAPPING,
    POST_GCP_RESOURCE_SERVICE_MAPPING,
    GET_GCP_ALL_RESOURCE_COUNT,
    GET_USER_RESCAN_STATUS_GCP
} from "./actionTypes";
import {
    getGcpRefreshSuccess,
    getGcpRefreshFail,
    getGCPNotificationChannelsSuccess,
    getGCPNotificationChannelsFail,
    postGCPCreateResourceAlertsSuccess,
    postGCPCreateResourceAlertsFail,
    postGCPResourceOpsGenieTeamMappingSuccess,
    postGCPResourceOpsGenieTeamMappingFail,
    postGCPResourceServiceMappingSuccess,
    postGCPResourceServiceMappingFail,
    postGCPResourcePagerdutyServiceMappingSuccess,
    postGCPResourcePagerdutyServiceMappingFail,
    getGCPAllResourceAlertsPageSuccess,
    getGCPAllResourceAlertsPageFail,
    getAllOrgGCPResourceTypesSuccess,
    getAllOrgGCPResourceTypesFail,
    getGCPCloudResourcesFail,
    getGCPCloudResourcesSuccess,
    getGCPResourceCountSuccess,
    getGCPResourceCountFail, getGCPRefreshScanStatusSuccess, getGCPRefreshScanStatusFail,
} from "./actions";
import {
    getRefreshGCPResources,
    getGCPNotificationChannelsUrl,
    postCreateGcpResourceAlertsUrl,
    postGCPResourceOpsgenieTeamMapping,
    postGCPServiceMapping,
    postGCPResourcePagerdutyServiceMappingCall,
    getGCPAllResourceAlertsPageUrl,
    getAllOrgGCPResourceTypesUrl,
    getGCPCloudResources,
    getGCPAllResourceCountPageUrl,  getRescanStatusGCPUrl,
} from "../../helpers/fakebackend_helper";
import { showNotification } from "components/Common/notification";

function* onGetGcpRefresh() {
    try {
        const response = yield call(getRefreshGCPResources);
        yield put(getGcpRefreshSuccess(response));
        if (response.scan_completed === false){
            showNotification('error', response.message);
        }
    } catch (error) {
        yield put(getGcpRefreshFail(error));
        if (error.response.data.message = "Plan has expired") {
            showNotification("error", "Your subscription has expired. Please renew!");
        }
    }
}

function* onGetGCPNotificationChannels() {
    try {
        const response = yield call(getGCPNotificationChannelsUrl);
        yield put(getGCPNotificationChannelsSuccess(response));
    } catch (error) {
        yield put(getGCPNotificationChannelsFail(error));
    }
}

function* onPostGCPCreateResourceAlerts({ payload: { data } }) {
    try {
        const response = yield call(postCreateGcpResourceAlertsUrl, data);
        yield put(postGCPCreateResourceAlertsSuccess(response));
    } catch (error) {
        yield put(postGCPCreateResourceAlertsFail(error));
        if (error.response.data.message === "Plan has expired") {
            showNotification("error", "Your subscription has expired. Please renew!");
        }
    }
}

function* onPostGCPResourceOpsgenieTeamMapping({ payload: { data } }) {
    try {
        const response = yield call(postGCPResourceOpsgenieTeamMapping, data);
        yield put(postGCPResourceOpsGenieTeamMappingSuccess(response));
        toastr.success("Opsgenie Team Mapping updated successfully!");
        yield new Promise(resolve => setTimeout(resolve, 3000));
        window.location.reload();
    } catch (error) {
        yield put(postGCPResourceOpsGenieTeamMappingFail(error.message));
    }
}

function* onPostResourceServiceMapping({ payload: { data } }) {
    try {
        const response = yield call(postGCPServiceMapping, data);
        yield put(postGCPResourceServiceMappingSuccess(response));
        if (response) {
            showNotification("success", "Service Mapping updated successfully!");
        }
    } catch (error) {
        yield put(postGCPResourceServiceMappingFail(error.message));
        if (error) {
            showNotification("error", "Failed to update");
        }
    }
}

function* onPostResourcePagerdutyServiceMapping({ payload: { data } }) {
    try {
        const response = yield call(postGCPResourcePagerdutyServiceMappingCall, data);
        yield put(postGCPResourcePagerdutyServiceMappingSuccess(response));
        toastr.success("Pagerduty service mapped successfully!");
        yield new Promise(resolve => setTimeout(resolve, 3000));
        window.location.reload();
    } catch (error) {
        yield put(postGCPResourcePagerdutyServiceMappingFail(error.message));
    }
}

function* onGetGcpAllResourceAlertsPage({ payload: { page_filters } }) {
    try {
        const response = yield call(getGCPAllResourceAlertsPageUrl, page_filters);
        yield put(getGCPAllResourceAlertsPageSuccess(response));
    } catch (error) {
        yield put(getGCPAllResourceAlertsPageFail(error.message));
    }
}

function* onGetGcpAllResourceCountPage({ payload: { page_filters } }) {
    try {
        const response = yield call(getGCPAllResourceCountPageUrl, page_filters);
        yield put(getGCPResourceCountSuccess(response));
    } catch (error) {
        yield put(getGCPResourceCountFail(error.message));
    }
}

function* onGetAllOrgGCPResourceTypes() {
    try {
        const response = yield call(getAllOrgGCPResourceTypesUrl);
        yield put(getAllOrgGCPResourceTypesSuccess(response));
    } catch (error) {
        yield put(getAllOrgGCPResourceTypesFail(error.message));
    }
}

function* onGetGCPCloudResources() {
    try {
        const response = yield call(getGCPCloudResources);
        yield put(getGCPCloudResourcesSuccess(response));
    } catch (error) {
        yield put(getGCPCloudResourcesFail(error.message));
    }
}

function* onGetGCPRescanStatus() {
    try {
        const response = yield call(getRescanStatusGCPUrl);
        yield put(getGCPRefreshScanStatusSuccess(response));
    } catch (error) {
        yield put(getGCPRefreshScanStatusFail(error.message));
    }
}


function* GCPSaga() {
    yield takeEvery(GET_GCP_REFRESH, onGetGcpRefresh);
    yield takeEvery(GET_GCP_NOTIFICATION_CHANNELS, onGetGCPNotificationChannels);
    yield takeEvery(GET_GCP_ALL_RESOURCE_ALERTS_PAGE, onGetGcpAllResourceAlertsPage);
    yield takeEvery(GET_GCP_ALL_RESOURCE_COUNT, onGetGcpAllResourceCountPage);
    yield takeEvery(GET_ALL_ORG_GCP_RESOURCE_TYPES, onGetAllOrgGCPResourceTypes);
    yield takeEvery(GET_GCP_CLOUD_RESOURCES, onGetGCPCloudResources);
    yield takeEvery(POST_GCP_CREATE_RESOURCE_ALERTS, onPostGCPCreateResourceAlerts);
    yield takeEvery(POST_GCP_RESOURCE_OPSGENIE_TEAM_MAPPING, onPostGCPResourceOpsgenieTeamMapping);
    yield takeEvery(POST_GCP_RESOURCE_SERVICE_MAPPING, onPostResourceServiceMapping);
    yield takeEvery(POST_GCP_RESOURCE_PAGERDUTY_SERVICE_MAPPING, onPostResourcePagerdutyServiceMapping);
    yield takeEvery(GET_USER_RESCAN_STATUS_GCP, onGetGCPRescanStatus);
}

export default GCPSaga;
